var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-table-list',{attrs:{"table-data":this.evaluationInfo.evaluationBusinessConsultList || [],"table-label":_vm.tableLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }